export enum ImageTypes {
    ScannedDocument = 1,
    VehiclePhoto = 2,
    Other = 3
}
